export interface ActionState {
  disabled: boolean;
  tooltip: string | undefined;
  hidden: boolean;
}

export const hidden = (tooltip?: string): ActionState => ({
  disabled: true,
  hidden: true,
  tooltip
});

export const disabled = (tooltip: string): ActionState => ({
  disabled: true,
  hidden: false,
  tooltip
});

export const enabled: ActionState = {
  disabled: false,
  hidden: false,
  tooltip: undefined
};
